class TimerUtil {
  static async delay(milliseconds: number) {
    return new Promise(res => setTimeout(res, milliseconds));
  }
}

export { TimerUtil as default };
